import { type ComponentProps } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface Props extends ComponentProps<"button"> {
  active?: boolean;
}

export const Button = ({
  className,
  active,
  disabled,
  children,
  ...props
}: Props) => {
  return (
    <button
      disabled={disabled}
      className={twMerge(
        clsx(
          "h-8 px-4 border border-v2-secondary mr-[-1px] hover:bg-v2-action-tertiary",
          "focus:z-1 active:z-1 focus:border-v2-cosmic/600 active:border-v2-cosmic/600",
          "focus:ring-2 focus:ring-v2-cosmic/200",
          {
            "pointer-events-none": disabled,
            "text-v2-action-hover bg-v2-secondary": active,
          },
        ),
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
